import React from 'react';
import Card from './card';
import './content.scss';

const Content = ({data}) => {
  return (
    <>
      {
        data.list && data.list.length > 0 && data.list.map((item) => {
          return <Card key={item.biz_id} data={item} />
        })
      }
      {
        data.more && <div className="athm-loading">
          <i className="athm-iconpng athm-iconpng-loadingblue athm-iconpng-loadingwhite"></i>加载中...
        </div>
      }
    </>
  )
}

export default Content;